import React from "react";
import { NeoBadge } from "../../../../../components/Common";
import { calculateRunningBlockSummary } from "../../domain/running/calculations";
import { RUNNING_BLOCK_TYPES } from "../../domain/running/constants";

const getBlockTypeLabel = (value) =>
    RUNNING_BLOCK_TYPES.find(item => item.value === value)?.label || value || "Bloco";

const RunningBlockSummary = ({ block = {} }) => {
    const summary = calculateRunningBlockSummary(block);

    return (
        <div className="running-block-summary">
            <div className="d-flex flex-wrap align-items-center gap-2">
                <NeoBadge variant="dark">{getBlockTypeLabel(block.blockType)}</NeoBadge>
                <span className="neo-stat-badge">{summary.segmentsCount} segmento{summary.segmentsCount !== 1 ? "s" : ""}</span>
                <span className="neo-stat-badge">{summary.repeats}x bloco</span>
                <span className="neo-stat-badge">{summary.distanceKm.toFixed(1).replace(".", ",")} km</span>
                {summary.durationMin > 0 && (
                    <span className="neo-stat-badge">{Math.round(summary.durationMin)} min</span>
                )}
                {block.restBetweenRepeats && (
                    <span className="neo-stat-badge">Rec: {block.restBetweenRepeats}</span>
                )}
            </div>
            {summary.zones.length > 0 && (
                <div className="running-zone-list mt-2">
                    {summary.zones.map(zone => (
                        <span key={zone.value} className="running-zone-pill" style={{ "--running-zone-color": zone.color }}>
                            {zone.label}: {zone.distanceKm > 0 ? `${zone.distanceKm.toFixed(1).replace(".", ",")} km` : `${Math.round(zone.durationMin)} min`}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RunningBlockSummary;
